// src/authConfig.js
export const msalConfig = {
    auth: {
        clientId: "2c66bd4a-9add-4bfe-9519-a3de96db2d25",
        authority: "https://login.microsoftonline.com/7d8c917c-9893-427d-a670-8c508ffb8de5",
        redirectUri: window.location.origin,
        postLogoutRedirectUri: window.location.origin,
    },
    cache: { cacheLocation: "sessionStorage", storeAuthStateInCookie: false },
};

// Scopes needed for Option 2 (Graph membership check)
export const loginRequest = {
    scopes: ["User.Read", "GroupMember.Read.All"],
};
